/* eslint-disable max-len */
import React from 'react'
import ThreeDotsLoader from '../../Components/LoadingDots';

export default function ClearCart({setremovePopup,setremoveLoader,loading,handleClearCart}) {
    return (
        <div className="modal-dialog modal-dialog-centered relative pointer-events-none sm:max-w-[444px] w-auto px-2" style={{margin: 'auto'}}>
            <div className="modal-content shadow-s8 border-none relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
                <div className="modal-header flex flex-shrink-0 items-center justify-between sm:p-5 pb-4 pt-6 px-1 rounded-t-md">
                    <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel2">
                        Remove Product
                    </h5>
                    <button type="button"
                        onClick={()=>setremovePopup('')}
                        className="btn-close1 box-content w-3.5 h-3.5 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline absolute sm:top-4 top-2.5 right-2 sm:right-6"
                        data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div className="modal-body relative sm:px-7 px-3 sm:pt-1 pt-0 sm:pb-6 pb-4 text-center">
                    <p className="text-xs6 font-normal text-[#555259] sm:pb-6 pb-3">
                        Cart contains products, Are you sure you want to remove all the product from the cart?
                    </p>
                    {/* <p className="bg-[#D8DDE3] py-1 rounded-lg">
                        <span className="text-sm font-semibold text-[#1D1D1D]">
                            Note:
                        </span>
                        <span className="text-sm font-normal text-[#555259] text-center">
                            Removing a product might affect the offer applied.
                        </span>
                    </p> */}
                </div>
                <div className="modal-footer flex flex-shrink-0 flex-wrap justify-evenly sm:pb-5 pb-4 rounded-b-md">
                    <button
                        onClick={()=>setremovePopup('')} type="button" className="border border-[#555259] bg-[#ffffff] sm:text-xs6 text-sm font-normal text-[#555259] sm:py-3 py-2 sm:px-9 px-6 rounded-lg" data-bs-dismiss="modal" aria-label="Close">
                        Cancel
                    </button>
                    <button
                        onClick={()=>{
                            setremoveLoader(true)
                            handleClearCart();
                        }}
                        type="button" className="bg-[#555259] font-normal text-[#ffffff] sm:text-xs6 text-sm sm:py-3 py-2 sm:px-12 px-9 rounded-lg remove-product flex justify-center items-center" data-bs-dismiss="modal" aria-label="Close">
                        {loading?<ThreeDotsLoader/>:'Yes'}
                    </button>
                </div>
            </div>
        </div>
    )
}
